define(['app/controllers/Controller', 'rv!app/views/recentProduct', 'app/helpers/helpers'], function (
    Controller,
    template,
    helpers
) {
    function RecentProductsController() {
        var Ractive = Controller.ractive;

        function init() {
            partyking.common.on('recentProductsLoaded', (data) => {
                if (partyking.common.models.recentProducts.products.length > 0) {
                    $('.recently-viewed-wrapper').removeClass('hidden');

                    var ractive = new Ractive({
                        el: '#recently-viewed',
                        template: template,
                        magic: true,
                        data: {
                            products: data.products,
                            module: data.module,
                        },
                    });

                    helpers.initModuleRecentProductTracking();
                }
            });
        }

        init();
    }

    return RecentProductsController;
});
